module.exports = __webpack_public_path__ + "img/brzj.66782110.png";